import { useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { formatters } from '@frontend/shared';
import { useSearch } from '@frontend/weave-router';
import { MultiOverview } from '../../components/multi-overview';
import { ARMultiComparisonConversionChart } from '../charts/ar-multi-comparison-conversion-chart';
import { ARMultiComparisonNoShowChart } from '../charts/ar-multi-comparison-no-show-chart';
import { useARRoiShallowStore } from '../hooks/use-ar-roi-store';
import { useFetchARROIOOverview } from '../hooks/use-fetch-ar-roi-overview';

export const ARRoiMultiSubView = (props: ReturnType<typeof useFetchARROIOOverview>) => {
  const { t } = useTranslation('analytics');
  const { filters } = useARRoiShallowStore('filters');
  const search = useSearch({ strict: false }) ?? {
    view: 'arConversion',
  };
  const ChartComponent =
    search.view === 'arConversion' ? ARMultiComparisonConversionChart : ARMultiComparisonNoShowChart;
  const locationsCount = filters?.locationIds?.length || 0;

  const overview = useMemo(() => {
    let value = '0';
    let message = '';

    switch (search.view) {
      case 'arConversion':
        value = formatters.percent(
          (props?.aggregated?.appointmentsCompleted?.appointmentsCompletedByReminders || 0) /
            (props?.aggregated?.appointmentsCompleted?.totalAppointmentsCompleted || 1)
        );
        message = t('of the total appointments completed were attributed to appointment reminders');
        break;

      case 'noShowRate':
        value = formatters.appendPercent(Math.abs(props?.aggregated?.noShowRate?.difference || 0));
        message = t(
          "is the average reduction in no-show rates for practices using Appointment Reminders compared to those that don't."
        );
        break;
    }

    return {
      message,
      value,
    };
  }, [props.aggregated, locationsCount, search.view]);

  return (
    <>
      <MultiOverview message={overview.message} miniGap value={overview.value} />
      <ChartComponent {...props} />
    </>
  );
};
